import React, { useState, useContext, useEffect } from "react";
import { Group, InfoContext } from "../InfoContext";
import { AuthContext } from "../AuthContext";
import { UserContext } from "../UserContext";
import GroupManageCard from "./components/GroupManageCard";
import GroupMatchesCard from "./components/GroupMatchesCard";
const Refereeing: React.FC = () => {
  const [selectedSeasonId, setSelectedSeasonId] = useState("");
  const { role } = useContext(AuthContext);
  const { user } = useContext(UserContext);

  const { seasons, getSeasonById } = useContext(InfoContext);
  const selectedSeasonIdInt = parseInt(selectedSeasonId, 10);
  const selectedSeason = getSeasonById(selectedSeasonIdInt);
  useEffect(() => {
    if (seasons.length > 0) {
      const maxId = Math.max(
        ...seasons
          .filter((season) => season.groups.length > 0)
          .map((season) => season.id)
      );
      setSelectedSeasonId(String(maxId));
    }
  }, [seasons]);

  const getUserGroup = (groupId: number): Group | undefined => {
    return selectedSeason?.groups.find(
      (group) =>
        group.id === groupId &&
        group.teams.some((team) => team.id === user?.member_of)
    );
  };
  const group = selectedSeason?.groups.find((group) => !getUserGroup(group.id));

  const groupMatches =
    selectedSeason?.matches.filter(
      (match) =>
        match.match_stage === group?.name.replace(/\s/g, "").toUpperCase()
    ) || [];
  return (
    <div className="flex flex-col justify-start items-center w-full h-full overflow-y-auto p-4 gap-y-4">
      <form className="flex flex-col text-black bg-white rounded-xl shadow-md w-full max-w-32 gap-y-4">
        <select
          id="seasonSelect"
          value={selectedSeasonId}
          onChange={(e) => setSelectedSeasonId(e.target.value)}
          className="w-full px-3 py-2 border rounded-xl "
          required
        >
          {seasons.map((season) => (
            <option key={season.id} value={season.id}>
              {season.name}
            </option>
          ))}
        </select>
      </form>
      <div
        className={` text-white max-w-3xl w-full grid grid-cols-1 gap-x-2 gap-y-4 ${
          role === "ADMIN" ? "" : ""
        }`}
      >
        {group && (
          <GroupMatchesCard
            key={group.id}
            groupName={group.name}
            matches={groupMatches}
            for_ref={true}
          />
        )}
        {!group && (
          <div className="bg-white/10 rounded-xl p-4 text-white max-w-3xl w-full">
            <h3 className="text-2xl font-bold">Group ...</h3>
            <p>
              You are not a member of any group in this season. Please join a
              team to see your matches!
            </p>
          </div>
        )}
        {selectedSeason?.groups.length === 0 && (
          <div className="bg-white/10 rounded-xl p-4 text-white max-w-3xl w-full">
            <h3 className="text-2xl font-bold">Group ...</h3>
            <p>This Season has no groups yet, please create some!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Refereeing;
